
      
      import request from '@/utils/request'
      export  async function loadTxtFile(filePath) {
            
            try {
                // 使用fetch API读取文件
                const response = await fetch(filePath, {
                    method: 'GET', // *GET, POST, PUT, DELETE, etc.
                    mode: 'cors', // no-cors, *cors, same-origin
                    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                    //credentials: 'same-origin', // include, *same-origin, omit
                    headers: {
                       'Content-Type': ' text/plain',
                       //'Access-Control-Allow-Origin': '*'
                        // 'Content-Type': 'application/json'
                        //  'Content-Type': 'application/x-www-form-urlencoded',
                    },
                   // redirect: 'follow', // manual, *follow, error
                   // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                  //  body: JSON.stringify(data) // body data type must match "Content-Type" header
                  });
                if (!response.ok) {
                    throw new Error(`HTTP错误! 状态: ${response.status}`);
                }
                
                 const textContent = await response.text();
                
                // const response = await request({
                //     url:filePath,
                //     method: 'get',
                   
                //   })
                
                // 处理文件内容
                const processedWords = processTextContent(textContent);
                return processedWords;
                
            } catch (error) {
                console.error('文件加载错误:', error);
                return [];
            }
        }

        function processTextContent(content) {
            const words = content.split('\n')
                .map(line => line.trim())
                .filter(line => {
                    // 过滤空行和注释
                    return line && !line.startsWith('#') && !line.startsWith('//');
                })
                .map(line => {
                    // 移除行内注释
                    return line.replace(/#.*$/, '').trim();
                })
                .filter(word => word.length > 0);
            
            return words;
        }
